
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Badge } from "@/types/elements";

@Component({
  components: {}
})
export default class ElementBadge extends Vue {
  @Prop()
  value!: Badge;

  get style() {
    return {
      backgroundColor: this.value.backgroundColor,
      color: this.value.textColor
    };
  }
}
